import Form from "components/Form";
import ImageUpload from "components/Form/ImageUpload";
import Input from "components/Form/Input";
import ReactSelect from "components/Form/ReactSelect";
import SaveChangesButton from "components/Form/SaveChangesButton";
import Loader from "components/shared/loader";
import { useEffect } from "react";
import { Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  getIdentityVerification,
  submitIdentityVerification,
} from "store/actions";
import { getAllCountries } from "store/data/actions";

export default function IdentityVerification() {
  const { countries, loading: countriesLoading } =
    useSelector((state) => state?.data) || [];
  const { identity, loading } = useSelector((state) => state?.settings) || [];
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCountries());
    dispatch(getIdentityVerification());
  }, [dispatch]);
  const defaultValues = {
    ...identity?.[0],
    issuingDate: identity?.[0]?.issuingDate?.split("T")?.[0],
    expirationDate: identity?.[0]?.expirationDate?.split("T")?.[0],
  };

  const onSubmit = (data) => {
    dispatch(submitIdentityVerification(data));
  };
  if (loading || countriesLoading) return <Loader />;

  return (
    <div className="table-wrap">
      <div className="card form-group">
        <Col xl={6} md={12} xs={12}>
          <div className="card-head">
            <div>
              <h4>
                <FormattedMessage id={"identityVerification"} />
              </h4>
            </div>
          </div>
        </Col>
        <Form onSubmit={onSubmit} defaultValues={defaultValues}>
          <Input name="fullName" />

          <ReactSelect name="issuingCountry" options={countries || []} />
          <ReactSelect name="IdType" options={["personalId", "passport"]} />
          <Input name="idNumber" />
          <Input type="date" name="issuingDate" />
          <Input type="date" name="expirationDate" />

          <ImageUpload name="idImage" classNames="m-auto" />
          <SaveChangesButton className="mt-2 justify-content-end" />
        </Form>
      </div>
    </div>
  );
}
